(function () {
  const THRESHOLD = 769;
  const PC_SELECTOR = '.pcdom,.pcDom, .pc';
  const MOBILE_SELECTOR = '.mobliedom,.moblieDom, .moblie';
  let mobileMode = window.innerWidth < THRESHOLD;
  const isEl = (n) => n && n.nodeType === 1;
  function stash(el, group) {
    if (!isEl(el) || !el.isConnected) return;
    const tpl = document.createElement('template');
    tpl.setAttribute('data-stash', group); // 标记分组
    el.replaceWith(tpl);
    tpl.content.appendChild(el);
  }
  function stashMatching(root, selector, group) {
    if (isEl(root) && root.matches(selector)) {
      stash(root, group);
      return;
    }
    const list = root.querySelectorAll ? root.querySelectorAll(selector) : [];
    list.forEach((el) => el.isConnected && stash(el, group));
  }

  function restoreGroup(group) {
    document.querySelectorAll(`template[data-stash="${group}"]`).forEach((tpl) => {
      const node = tpl.content.firstChild;
      if (node) tpl.replaceWith(node);
    });
  }

  if (mobileMode) {
    stashMatching(document, PC_SELECTOR, 'pc');
  } else {
    stashMatching(document, MOBILE_SELECTOR, 'mobile');
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes &&
        m.addedNodes.forEach((node) => {
          if (!isEl(node)) return;

          if (mobileMode) {
            if (node.matches(PC_SELECTOR)) {
              stash(node, 'pc');
            } else {
              stashMatching(node, PC_SELECTOR, 'pc');
            }
          } else {
            if (node.matches(MOBILE_SELECTOR)) {
              stash(node, 'mobile');
            } else {
              stashMatching(node, MOBILE_SELECTOR, 'mobile');
            }
          }
        });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  let resizeTimer;
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const nowMobile = window.innerWidth < THRESHOLD;
      if (nowMobile === mobileMode) return; // 模式没变
      mobileMode = nowMobile;
      if (mobileMode) {
        restoreGroup('mobile');
        stashMatching(document, PC_SELECTOR, 'pc');
      } else {
        restoreGroup('pc');
        stashMatching(document, MOBILE_SELECTOR, 'mobile');
      }
    }, 150);
  }

  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
  window.__toggleObserver = observer;
  window.__toggleDebug = { restoreGroup, stashMatching };
})();
